import React from 'react'
import styled from 'styled-components/macro'
import estyled from '@emotion/styled'
import { GelHeading4, GelParagraph } from '@tal-gel/components'
import { getGelTokens } from '@tal-gel/theming'

import Logo from '../../components/Logo/Logo'
import plus from './assets/plus.svg'

const Component = styled.div`
  padding: 56px 24px;
  display: flex;
  justify-content: center;

  @media only screen and (min-width: 768px) {
    padding: 96px 48px;
  }
`

const InnerWrapper = styled.div`
  @media only screen and (min-width: 768px) {
    max-width: 1032px;
    display: flex;
    justify-content: space-between;
    width: 100%;
  }
`

const Content = styled.div`
  max-width: 520px;
`

const Images = styled.div`
  display: flex;
  align-items: center;
  justify-content: ${(props) => (props.demo ? 'center' : 'space-between')};
  margin-bottom: 30px;

  /* tal */
  & > img:first-child {
    width: 131px;
  }

  /* cbus */
  & > img:last-child {
    width: 72px;
    max-width: none;
  }

  @media only screen and (min-width: 768px) {
    width: 100%;
    max-width: 307px;
    justify-content: ${(props) => (props.demo ? 'center' : 'space-between')};
    margin-right: 48px;
    margin-bottom: 0;

    /* tal */
    & > img:first-child {
      width: 101px;
    }

    /* cbus */
    & > img:last-child {
      width: 100px;
      max-width: none;
    }
  }
`

const GelParagraphColored = estyled(GelParagraph)`
  color: ${() => getGelTokens().brand.brandColorGrayT50};
  font-weight: 400;
`

const Icon = styled.img`
  width: 27px;
`

const About = ({ demo }) => (
  <Component>
    <InnerWrapper>
      <Images demo={demo}>
        <Logo version='short' />
        {!demo && <Icon src={plus} alt='plus' />}
        {!demo && <Logo version='cbus' />}
      </Images>
      <Content>
        <GelHeading4 marginBottom={12}>
          Who is behind TAL Health Sense?
        </GelHeading4>
        <GelParagraphColored large>
          {demo
            ? `Super fund X has partnered with Australia’s leading life insurance specialist TAL, to bring you TAL Health Scout. TAL is always thinking of new ways to protect every aspect of this Australian life and health is at the
            heart of that. Whether its sharing expert health insights or providing
            members simple ways to keep an eye on their health, TAL’s goal is to
            help Australians live as healthy and full life as possible.`
            : `Cbus has partnered with Australia’s leading life insurance specialist
          TAL, to bring you TAL Health Scout. TAL is always thinking of new ways
          to protect every aspect of this Australian life and health is at the
          heart of that. Whether its sharing expert health insights or providing
          members simple ways to keep an eye on their health, TAL’s goal is to
          help Australians live as healthy and full life as possible.`}
        </GelParagraphColored>
      </Content>
    </InnerWrapper>
  </Component>
)

export default About
